import { Box, Button, Stack } from "@mui/material"
import { use, useEffect, useState } from "react"
import Spinner from "../Spinner/Spinner"
import { Getter } from "../../services/ComService"
enum Status {
  loading,
  ready,
}
export default function BTCList({
  onClick,
}: {
  onClick?: (id: number, name: string) => void,
}) {
  const [list, setList] = useState<{ id: number, name: string }[]>([])
  const [status, setStatus] = useState(Status.loading)
  useEffect(() => {
    Getter('getbtcs').then(result => {
      setList(result.users)
      setStatus(Status.ready)
    })
  }, [])
  return <Stack
    spacing={0}
    sx={{
      padding: 2,
    }}
  >
    <h2>BTC Liste</h2>
    {
      status === Status.loading &&
      <Spinner />
    }
    { status === Status.ready &&
      list.map((item) => {
        return <Button
            key={`selectresponsible-${item.id}`}
            onClick={() => {
              if (onClick) {
                onClick(item.id, item.name)
                return
              }
            }}
            sx={{
              justifyContent: 'flex-start',
              textTransform: 'none',
            }}
          >
            {item.name}
        </Button>
      })
    }
    </Stack>
}